import styled from 'styled-components/native';

export default styled.Text`
  font-size: 11px;
  color: ${({ theme }) => theme.marketplace.decoratedTitleText};
  opacity: 0.52;
  margin-top: 22px;
`;
